var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"Tabs"},_vm._l((_vm.tabs),function(tab,index){return _c('div',{key:index,class:[{'Tabs--active': _vm.current === tab},'Tabs__item'],on:{"click":function($event){_vm.changeTab(tab)}}},[_vm._v("\n            "+_vm._s(tab.title)+"\n        ")])})),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05491c9d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tabs/tabs.vue
// module id = null
// module chunks = 